module.exports = __webpack_public_path__ + "img/selfCheck-selected.a91f40cd.png";